import { fieldTypeConfig, isFillableFieldType } from "@/pages/esign/esign.config.ts";
import { ApiEsignField, EsignFieldFilledBy, EsignFieldType } from "@/types/esign.types.ts";

export function isSignableField(field: ApiEsignField): boolean {
  return fieldTypeConfig[field.field_type].signable;
}

export function isSignerFillableField(field: ApiEsignField): boolean {
  return field.filled_by === EsignFieldFilledBy.signer && isFillableFieldType(field.field_type);
}

export function getFieldKey(field: ApiEsignField): string {
  return field.field_key;
}

export function getFieldText(field: ApiEsignField, translate: (key: string) => string): string {
  const value = field.value ?? "";
  if (field.field_type === EsignFieldType.yes_no) {
    if (value === "yes") return translate("common:yes");
    if (value === "no") return translate("common:no");
    return "";
  }
  return value;
}
